import { render } from "./Tos.vue?vue&type=template&id=e021ba46&scoped=true"
import script from "./Tos.vue?vue&type=script&lang=js"
export * from "./Tos.vue?vue&type=script&lang=js"

import "./footerPage.css?vue&type=style&index=0&id=e021ba46&scoped=true&lang=css"

import exportComponent from "/home/node/site/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e021ba46"]])

export default __exports__